"use client";

import { useEffect, useRef, useState } from "react";

/**
 * IntersectionObserver を利用した仮想化フック。
 * ビューポート外の要素の重い描画をスキップし、描画コストを削減する。
 * rootMargin で 500px のバッファを持たせ、スクロール時のちらつきを防止。
 *
 * 一度ビューポートに入った要素は永続的に visible とし、
 * スクロールアウト時に描画済み DOM を破壊しない（one-shot）。
 */
export function useVirtualization(rootMargin = "500px") {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [rootMargin]);

  return { ref, shouldVirtualize: !isVisible };
}
